import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import {
  DEFAULT_DIRECTION,
  DEFAULT_GAPS,
  DEFAULT_MARGIN_END,
  DEFAULT_MARGIN_START
} from '@/widgets/EnclosureWithBlockTitle/config';
import { createNewFlexSectionData } from '@/widgets/FlexSection/create';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';
import { createNewImageData } from '@/widgets/Image/create';
import { createNewTextData } from '@/widgets/Text/create';

export function createNewEnclosureWithCombinedTitleData(content: string): ManifestInitializedProps {
  const id = genRandId();

  const [imageData] = createNewImageData();
  const [textData] = createNewTextData(content, 'header', false);

  const [horizontalSectionData] = createNewFlexSectionData(FlexSectionDirection.row, [
    { id: imageData.id, width: 60, height: 60, span: 1, column: 0, isDeletable: false, isDraggable: false },
    { id: textData.id, width: 300, height: 'auto', isDeletable: false, isDraggable: false }
  ]);
  const { id: horizontalSectionId } = horizontalSectionData;
  const childrenArray = new Y.Array();
  childrenArray.push([horizontalSectionId]);

  const [verticalSectionData] = createNewFlexSectionData(FlexSectionDirection.column);
  const { id: verticalSectionId } = verticalSectionData;
  childrenArray.push([verticalSectionId]);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.EnclosureWithCombinedTitle],
        ['children', childrenArray],
        [
          'style',
          new Y.Map([
            ['dropzoneDirection', DEFAULT_DIRECTION],
            ['dropzoneMarginStart', DEFAULT_MARGIN_START],
            ['dropzoneMarginEnd', DEFAULT_MARGIN_END],
            ['dropzoneGap', DEFAULT_GAPS]
          ])
        ]
      ])
    },
    horizontalSectionData,
    imageData,
    textData,
    verticalSectionData
  ];
}
